import s from './Icon.module.css';

const SPRITE = `${import.meta.env.BASE_URL}icons.svg`;

/** 16×16 线性图标，1.6 描边；图标集 public/icons.svg（与高保真稿 m-icons.svg 同一份） */
export function Icon({ name, size = 16, className }: { name: string; size?: 14 | 16 | 18 | 20 | 22 | 24; className?: string }) {
  return (
    <svg className={[s.ic, s[`s${size}`], className].filter(Boolean).join(' ')} aria-hidden="true">
      <use href={`${SPRITE}#i-${name}`} />
    </svg>
  );
}
